import { gql, type TypedDocumentNode } from '@apollo/client';
import type { ReactNode } from 'react';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { isType } from '@sorare/core/src/lib/gql';

import type { WithFlavour_anyRewardConfigInterface } from './__generated__/index.graphql.ts';

type Props = {
  anyRewardConfig: WithFlavour_anyRewardConfigInterface;
  children: ReactNode;
};

export const WithFlavour = ({ anyRewardConfig, children }: Props) => {
  if (
    !isType(anyRewardConfig, 'CardShardRewardConfig') ||
    !anyRewardConfig.flavour?.iconUrl ||
    anyRewardConfig.rarity === Rarity.common
  ) {
    return <>{children}</>;
  }

  const { iconUrl, displayName } = anyRewardConfig.flavour;

  return (
    <Horizontal gap={1}>
      {children}
      <img src={iconUrl} alt={displayName} width={20} height={20} />
    </Horizontal>
  );
};

WithFlavour.fragments = {
  anyRewardConfigInterface: gql`
    fragment WithFlavour_anyRewardConfigInterface on AnyRewardConfigInterface {
      id
      ... on CardShardRewardConfig {
        id
        rarity
        flavour {
          slug
          iconUrl
          displayName
        }
      }
    }
  ` as TypedDocumentNode<WithFlavour_anyRewardConfigInterface>,
};
